import { Banner } from "interfaces";
import Link from "next/link";
import cls from "./bannerSingle.module.scss";
import Image from "next/image";

type Props = {
  data: Banner;
};

export default function BannerSingle({ data }: Props) {
  return (
    <Link href={`/promotion/${data.id}`} className={cls.banner}>
      <div className={cls.wrapper}>
        <Image
          fill
          priority
          src={data?.img}
          alt={data.translation?.title}
          quality={90}
          sizes="(max-width: 376px) 340px, (max-width: 568px) 550px, (768px) 740px, (max-width: 992px) 960px, (max-width:1200px) 1160px, 1440px"
        />
      </div>
    </Link>
  );
}
